import React from "react";
import { Link } from "Components/Base/Navigation/Link";
import ButtonUnderlined from "Components/Fragment/ButtonUnderlined";
import { ARROW_RIGHT } from "Components/Icons";
import {
  STYLE_LEARNING_ACTIVITY_CARD_LINK,
  STYLE_CARD_LINK_HOVER,
} from "./style";

/**
 * A styled link component for learning activity cards
 * @param {string} href - The URL the link points to
 * @param {React.ReactNode} children - The content to render inside the link
 * @param {Object} props - Additional props to pass to the Link component
 * @returns {React.ReactElement} A styled Link component
 */
export const LearningActivityCardLink = ({
  href,
  children,
  rel = null,
  target = null,
  title = null,
}) => (
  <Link
    className="bold"
    href={href}
    color="inherit"
    {...(rel && { rel })}
    {...(title && { title })}
    {...(target && { target })}
    sx={STYLE_LEARNING_ACTIVITY_CARD_LINK}
  >
    <span className="sr-only">{title || children}</span>
    <ARROW_RIGHT />
  </Link>
);

/**
 * A styled button component for learning activity cards
 * @param {Function} onClick - Click handler function
 * @param {React.ReactElement} startIcon - Icon element to show at start of button
 * @param {string} label - Text label for the button
 * @param {string} title - Title for the button
 * @param {React.ReactNode} children - Optional child content
 * @returns {React.ReactElement} A styled Button component
 */

export const LearningActivityCardButton = ({
  onClick,
  startIcon,
  label,
  endIcon,
  title,
  style,
}) => (
  <ButtonUnderlined
    icon={endIcon || <ARROW_RIGHT />}
    color="inherit"
    onClick={onClick}
    startIcon={startIcon}
    label={label}
    hoverEffect={false}
    justifyContent="end"
    toolTipTitle={title}
    style={style}
    sx={{ color: "var(--colorTextPrimary)", ...STYLE_CARD_LINK_HOVER }}
  />
);
